function openModal(modalsState, modalName, params) {
	let newState

	if (!(modalsState.find(modal => modal.modalName === modalName))) {
		newState = [...modalsState, { modalName, visible: true, params }]
	} else {
		newState = modalsState
	}

	return newState
}

function closeModal(modalsState, modalName) {
	let newState

	const modalIndex = modalsState.findIndex(
		modal => modal.modalName === modalName
	)
	if (modalIndex === -1) {
		newState = modalsState
	} else {
		newState = [
			...modalsState.slice(0, modalIndex),
			...modalsState.slice(modalIndex + 1),
		]
	}

	return newState
}

export {
	openModal,
	closeModal,
}
